import { render } from "./IpRangesTabPublic.vue?vue&type=template&id=57aece2c&scoped=true"
import script from "./IpRangesTabPublic.vue?vue&type=script&lang=js"
export * from "./IpRangesTabPublic.vue?vue&type=script&lang=js"

import "./IpRangesTabPublic.vue?vue&type=style&index=0&id=57aece2c&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57aece2c"]])

export default __exports__